export default function CopyIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.18755 9.18701H11.8126V2.18701H4.81255V4.81201M2.1875 4.81207H9.1875V11.8121H2.1875V4.81207Z"
        stroke="#2D3643"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
